// extracted by mini-css-extract-plugin
export default {"imgdiv":"_9a33b01742 _87c48d6262","img":"_6cabf15fb5 e4671f7a8d"};